export default {
    label: 'Event Stage',
    description: 'Listen for this stage of an event.',
    key: 'eventType',
    type: 'select',
    multi: false,
    validate: {
        required: true
    },
    defaultValue: {
        type: 'equals',
        pattern: 'Event:created'
    },
    data: {
        values: [{
                label: 'Event:created',
                value: {
                    type: 'equals',
                    pattern: 'Event:created'
                }
            },
            {
                label: 'Event:updated',
                value: {
                    type: 'equals',
                    pattern: 'Event:updated'
                }
            }
        ]
    }
};
